import { render, staticRenderFns } from "./BaseLevelTableContainer.vue?vue&type=template&id=f5e783ba&scoped=true"
import script from "./BaseLevelTableContainer.vue?vue&type=script&lang=js"
export * from "./BaseLevelTableContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseLevelTableContainer.vue?vue&type=style&index=0&id=f5e783ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e783ba",
  null
  
)

export default component.exports